import PageCom from '@/page-components/register';
import { IdentityProvider } from '@/hooks/useIdentity';
import useGA from '@/hooks/useGa';
import { MyAES, safeDecodeURIComponent } from '@/utils/aes';
import { comeFrom } from '../login';
import { GetServerSideProps } from 'next';
import { INVITE_COOPERATION_EMAIL, INVITE_COOPERATION_ID, INVITE_KOL_EMAIL, INVITE_KOL_ID } from '@/page-components/invite/constants';

const getSessionItem = (key: string) => (typeof window !== 'undefined' ? sessionStorage.getItem(key) : null);

const Register: React.FC<{ query: Record<string, string> }> = ({ query }) => {
  const { utm_ydk, utm_yde, f, p } = query;
  const kol_id = safeDecodeURIComponent(utm_ydk);
  const kol_email = safeDecodeURIComponent(utm_yde);
  const from = comeFrom({ kol_id, kol_email, f, p });
  useGA({
    pageTitle: '注册页',
    params: {
      from,
      kol_id: getSessionItem(INVITE_COOPERATION_ID) || getSessionItem(INVITE_KOL_ID) || (kol_id && MyAES.decrypt(String(kol_id))),
      kol_email: getSessionItem(INVITE_COOPERATION_EMAIL) || getSessionItem(INVITE_KOL_EMAIL) || (kol_email && MyAES.decrypt(String(kol_email))),
    },
  });
  return (
    <IdentityProvider query={query}>
      <PageCom query={query} />
    </IdentityProvider>
  );
};
export const getServerSideProps: GetServerSideProps = async ({ query }) => {
  return { props: { query } };
};
export default Register;
